import React from 'react'

const OneDayTodo = ({ todo }) => (
  <span className="tag is-warning">
    いつの日かTODO : {todo}
  </span>
)

export default OneDayTodo
